/**
 * @ngdoc controllers
 * @memberof mercury.modules.grossprofit
 * @name ReportsGrossProfitOverviewCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.grossprofit')
.controller('ReportsGrossProfitOverviewCtrl', ["title", "reporttime", "ReportGrossProfit", "$scope", "$filter", function(title, reporttime, ReportGrossProfit, $scope, $filter) {
  title.set('Gross Profit Overview');

  $scope.reportResults = [];
  $scope.categories = {'All': []};
  $scope.categoryLabels = ['All'];
  $scope.graphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Gross Profit', type: 'number', key: 'grossProfit', filter: 'currency'}
  ];

  $scope.loading = ReportGrossProfit.getOverview(reporttime.start(), reporttime.end(), reporttime.interval());

  $scope.loading.then(function(result) {
    $scope.categories.All = result;
    for (var i = 0; i < result.length; i++) {
      var period = result[i];
      if (period.categories) {
        for (var category = 0; category < period.categories.length; category++) {
          var categoryName = period.categories[category].categoryName;
          if (!$scope.categories[categoryName]) {
            $scope.categories[categoryName] = [];
            $scope.categoryLabels.push(categoryName);
          }

          $scope.categories[categoryName].push({
            startTime: period.startTime,
            sales: period.categories[category].sales,
            wages: period.categories[category].wages,
            costOfGoods: period.categories[category].costOfGoods,
            grossProfit: period.categories[category].grossProfit,
            grossProfitPercentage: period.categories[category].grossProfitPercentage
          });
        }
      }
    }

    $scope.selectedCategory = 'All';
    $scope.setCategory();
  });

  $scope.setCategory = function() {
    $scope.reportResults = $scope.categories[$scope.selectedCategory];
    totalSales = $filter('sumof')($scope.reportResults, 'sales');
    $scope.totalPercentage = totalSales == 0 ? null : ($filter('sumof')($scope.reportResults, 'grossProfit') / totalSales) * 100;
  };
}]);
